import React from "react";
import { FormattedMessage } from "react-intl";

export enum TransactionReturnReasonName {
    DAMAGED = 'damaged',
    WRONG_PRODUCT = 'wrong_product',
    WRONG_SIZE = 'wrong_size'
}

export class TransactionReturnReason {
    static readonly DAMAGED = new TransactionReturnReason(
        TransactionReturnReasonName.DAMAGED,
        <FormattedMessage
            id='TransactionReturnReason.damaged'
            description='The displayed value for the TransactionReturnReason damaged'
            defaultMessage='Damaged'
        />
    );
    static readonly WRONG_PRODUCT = new TransactionReturnReason(
        TransactionReturnReasonName.WRONG_PRODUCT,
        <FormattedMessage
            id='TransactionReturnReason.wrong_product'
            description='The displayed value for the TransactionReturnReason wrong_product'
            defaultMessage='Wrong product'
        />
    );
    static readonly WRONG_SIZE = new TransactionReturnReason(
        TransactionReturnReasonName.WRONG_SIZE,
        <FormattedMessage
            id='TransactionReturnReason.wrong_size'
            description='The displayed value for the TransactionReturnReason wrong_size'
            defaultMessage='Wrong size'
        />
    );
    
    static getByValue(action: TransactionReturnReasonName): TransactionReturnReason | undefined {
        return this.ALL.find((a) => a.value == action);
    }
    
    private constructor(
        public readonly value: TransactionReturnReasonName,
        public readonly displayName: React.ReactNode
    ) {}

    static readonly ALL = [
        TransactionReturnReason.DAMAGED,
        TransactionReturnReason.WRONG_PRODUCT,
        TransactionReturnReason.WRONG_SIZE
    ];
    
}